export default __webpack_public_path__ + "static/media/6.12.5ece78bf.mp3";